interface ButtonFilledProps {
    label: string;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    fullWidth?: boolean;
    type?: 'button' | 'submit' | 'reset' | undefined;
    color?: string;
    disabled?: boolean;
}

export default ({ label, onClick, fullWidth, type = 'button', color = 'blue', disabled }: ButtonFilledProps) => {
    return (
        <button
            onClick={onClick}
            type={type}
            disabled={disabled}
            className={`py-2 px-4 capitalize text-white transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none rounded-md ${fullWidth ? 'w-full' : ''} ${
                disabled ? 'bg-gray-500' : `bg-${color}-700 hover:bg-${color}-900`
            }`}
        >
            {label}
        </button>
    );
};
